import React, { useEffect, useState } from 'react';
const SCRIPT_SRC = 'https://js.stripe.com/v3/buy-button.js';
type StripeElementProps = {
  'buy-button-id': string;
  'publishable-key': string;
  'client-reference-id'?: string;
};

// The Stripe buy button is a web component, so it is not in React's JSX types.
const StripeElement = 'stripe-buy-button' as unknown as React.FC<StripeElementProps>;
type StripeBuyButtonProps = {
  buyButtonId: string;
  publishableKey: string;
  clientReferenceId?: string;
};
export function StripeBuyButton({
  buyButtonId,
  publishableKey,
  clientReferenceId
}: StripeBuyButtonProps) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      setLoaded(true);
      return;
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => setLoaded(true);
    document.head.appendChild(script);
  }, []);
  if (!loaded) {
    return <div aria-hidden="true" className="h-12 w-full animate-pulse rounded-lg bg-forest/10" data-id="element-113" data-mp="rei8dxnstlal" />;
  }
  return <div className="flex w-full justify-center [&_stripe-buy-button]:inline-block" data-id="element-114" data-mp="116wairisgtxa">
      <StripeElement buy-button-id={buyButtonId} publishable-key={publishableKey} client-reference-id={clientReferenceId} data-id="element-115" data-mp="wfnxlli92qfd" />
    </div>;
}